module.exports = __webpack_public_path__ + "img/24h.c4066268.jpg";